import { Injectable } from '@angular/core';
import { Mapper } from "./mapper.service";
import { RuleCompiler } from "./rule-compiler.service";
import * as dto from "../../common/models/flow.dto";
import * as model from "../models/flow.model";

@Injectable({
  providedIn: 'root'
})
export class OnBehalfMapperService extends Mapper {

    constructor(public compiler: RuleCompiler) { super(compiler); }

    createButton(section: model.Section, page: model.Page, b: dto.Button, context: any): model.Button {

        let result = model.Button.create(b.type, {
            id: b.id,
            section: section,
            page: page,
            label: b.label,
            enabled: () => { return true; },
            visible: this.compiler.compileBooleanRule(b.visibleRule, context),
            notifyMessageRule: this.compiler.compileSyncRule<string>(b.notifyMessageRule, context, ""),
            redirectToRule: this.compiler.compileSyncRule<string>(b.redirectToRule, context, ""),
            targetTransition: b.type === dto.ButtonKind.Transition
                ? this.compiler.compileAsyncRule<string>(b.targetTransitionRule, context, "")
                : null,
            finalDestination: b.type === dto.ButtonKind.Return
                ? this.compiler.compileSyncRule<string>(b.targetTransitionRule, context, "")
                : null,
            targetPage: b.type === dto.ButtonKind.JumpToPage
                ? this.compiler.compileAsyncRule<number>(b.targetPageRule, context, -1)
                : null,
            targetSection: b.type === dto.ButtonKind.JumpToSection
                ? this.compiler.compileAsyncRule<number>(b.targetSectionRule, context, -1)
                : null,
            position: b.position,
            special: b.special,
            confirmAction: b.confirmAction,
            restrictingGroups: b.restrictingGroups,
            alwaysEnable: b.alwaysEnable
        });

        return result;
    }

    createInstance(f: dto.FlowInstance, context: any): model.FlowInstance {
        return super.createInstance(f, context);
    }

    createPage(s: model.Section, p: dto.Page, context: any, state: model.State): model.Page {
        let result = new model.Page({
            pageType: p.pageType,
            pageNumber: p.pageNumber,
            context: context,
            state: state,
            questions: (p.questions || []).map(o => o.map(q => this.createQuestion(q, context))),
            isSectionHead: p.isSectionHead,
            section: s.id,
            sectionTitle: s.name,
            subtitle: p.subtitle,
            buttons: [],
            incomingRules:
                (p.incomingRules || [])
                    .map(r => new model.ChangeTargetRule(this.compiler.compileAsyncRule(r, context, null),
                        r.contextTarget))
        });
        const nonadhocButtons = p.buttons.filter(b => b.type !== dto.ButtonKind.AddReviewer);
      //  result.buttons = (p.buttons || []).map(b => this.createButton(s, result, b, context));
        result.buttons = (nonadhocButtons || []).map(b => this.createButton(s, result, b, context));
        result.navigationButtons = result.buttons.filter(b => b.isNavigation);
        result.specialButtons = result.buttons.filter(b => b.isSpecial);
        const partiallyRequired: dto.Question[] = [];
        for (let r = 0; r < p.questions.length; r++) {
            for (let q = 0; q < p.questions[r].length; q++) {
                for (let v = 0; v < p.questions[r][q].validationRules.length; v++) {
                    partiallyRequired.push(p.questions[r][q]);
                }
            }
        }
        result.partiallyRequiredValid = this.compiler.compilePagePartiallyRequiredRule(partiallyRequired, context);
        return result;
    }

    createQuestion(q: dto.Question, context: any): model.Question {
       // const pageRules = q.validationRules.filter(vr => !vr.onSubmitOnly);
        const pageRules = [];
        const {
            pageValidationMessages = [],
            pageValidator = () => { }
        } = this.compiler.compileValidationRules(pageRules, context);        
        const {
            flowValidationMessages = [],
            flowValidator = () => { }
        } = this.compiler.compileFlowValidationRules(q, context);
        const visible = this.compiler.compileBooleanRule(q.visibleRule, context);
        const enabled = this.compiler.compileBooleanRule(q.enabledRule, context);
        let args = {
            questions: [],
            contextOptionSource: null,
            context: context,
            contextTarget: q.contextTarget,
            initialDataContextTarget: q.initialDataContextTarget,
            initialValue: this.compiler.compileSyncRule<any>(q.initialDataContextTargetRule, context, ""),
            enabled: this.generateEnabled(q, enabled, visible),
            helpText: q.helpText,
            key: q.key,
            label: q.label,
            pageValidationMessages: pageValidationMessages,
            pageValidator: pageValidator,
            flowValidationMessages: flowValidationMessages,
            flowValidator: flowValidator,
            visible: visible,
            changeRules: (q.changeRules || []).map(r => new model.ChangeTargetRule(this.compiler.compileAsyncRule(r, context, null), r.contextTarget, r.name)),
            flexGrow: q.flexGrow,
            defaultValue: q.defaultValue,
            config: q.config
        };
        
        if (q.type === dto.QuestionKind.Group) {
            args.questions = q.config.questions.map(qq => this.createQuestion(qq, context));
        }

        if (this._optionsQuestionKinds.find(qq => qq === q.type)) {
            args.contextOptionSource = q.config["contextOptionSource"];
        }
        let question = model.Question.create(q.type, args);

        return question;
    }
}
